import { render } from "./CLanguage.vue?vue&type=template&id=25dc33fb"
import script from "./CLanguage.vue?vue&type=script&lang=js"
export * from "./CLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__